var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.51,
    height: 44.51,
    viewBox: "0 0 44.51 44.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4743",
    "data-name": "Group 4743",
    transform: "translate(18646 -13657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M18.8,37.6A18.8,18.8,0,0,1,5.506,5.506,18.8,18.8,0,0,1,32.093,32.093,18.676,18.676,0,0,1,18.8,37.6Zm-3.261-17.32L8.873,26.7H28.511l-6.659-6.413c-.5.481-.922.885-1.121,1.082a2.829,2.829,0,0,1-2,.889,2.792,2.792,0,0,1-1.775-.661C16.8,21.47,16.286,20.989,15.539,20.279Zm13.877-7.187c-1.281,1.215-4.5,4.266-6.674,6.348l6.675,6.431Zm-21.347,0V25.778l6.588-6.347C12.709,17.57,10,14.955,8.069,13.089Zm.877-.857c3.783,3.658,8.366,8.067,8.833,8.456a1.428,1.428,0,0,0,2.014-.1l.05-.059c.794-.794,6.081-5.81,8.622-8.22l.085-.081Z",
    transform: "translate(-18646 13657)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailWhite);
export default __webpack_public_path__ + "static/media/email-white.85c6c4876fb1a9fb6fd92604f1000d55.svg";
export { ForwardRef as ReactComponent };